import { FaCheckSquare, FaGraduationCap } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { Redirect } from "react-router-dom";
import PreviewTableFour from "./PreviewTables/PreviewTableFour";
import PreviewTableOne from "./PreviewTables/PreviewTableOne";
import PreviewTableThree from "./PreviewTables/PreviewTableThree";
import PreviewTableTwo from "./PreviewTables/PreviewTableTwo";

const PreviewApplication = ({ files, work, tertiary ,ordLevel, mode, level, programme1, programme2, programme3,  title, setTitle, forenames, surname,  dob, setDob, gender,  maritalStatus, placeOfBirth, nationality, citizenship,idNumber, email,  phoneNumber,  address }) => {
    //console.log(tertiary);
    const backToHone = () => {
        setTimeout(() => {
            <Redirect to="/" />
        }, 2000);
    }
    //console.log(tertiary.length)
    return ( 
        <>
            <h5 className="title is-size-5-touch has-text-weight-semibold mt-6 mb-2 grey-text text-darken-3">Complete Application</h5>
            <div className="divider mb-5"></div>
    
            <ul className="collection with-header">
                <li className="collection-header is-size-5">Selected Programs </li>
                <li className="collection-item">
                    <FaGraduationCap fontSize="1.3rem"  className="mr-3"/>
                    <span>{ programme1 }</span>
                </li>
                <li className="collection-item">
                    <FaGraduationCap fontSize="1.3rem"  className="mr-3"/>
                    <span>{ programme2 }</span>
                </li>
                <li className="collection-item">
                    <FaGraduationCap fontSize="1.3rem"  className="mr-3"/>
                    <span>{ programme3 }</span>
                </li>
            </ul>
            <div className="row">
                <div className="col s6">
                    <h5 className="is-size-5 has-text-weight-semibold  grey-text text-darken-3">Level</h5>
                    <h4 className="is-size-6 has-text-weight-semibold grey-text text-darken-2">{ level }</h4>
                </div>
                <div className="col s6">
                    <h5 className="is-size-5 has-text-weight-semibold  grey-text text-darken-3">Mode</h5>
                    <h4 className="is-size-6 has-text-weight-semibold  grey-text text-darken-2">{ mode }</h4>
                </div>
            </div>
            <h5 className="is-size-5 has-text-weight-semibold mt-5 mb-4 grey-text text-darken-3">Personal Information</h5>
            <div className="grey lighten-5 smooth-edge-2 pl-2 row pt-5 pb-2">
                <div className="col s12 m4 mb-3">
                    <span>{title} {forenames} {surname}</span>
                </div>
                <div className="col s12 m4 mb-3">
                    <span>DOB: {dob}</span>
                </div>
                <div className="col s12 m4 mb-3">
                    <span>{gender}</span>
                </div>
                <div className="col s12 m4 mb-3">
                    <span>{maritalStatus}</span>
                </div>
                <div className="col s12 m4 mb-3">
                    <span>Place of Birth: {placeOfBirth}</span>
                </div>
                <div className="col s12 m4 mb-3">
                    <span>Nationality: {nationality}</span>
                </div>
                <div className="col s12 m4 mb-3">
                    <span>Citizenship: {citizenship}</span>
                </div>
                <div className="col s12 m4 mb-3">
                    <span>{ idNumber }</span>
                </div>
                <div className="col s12 m4 mb-3">
                    <span>{ email }</span>
                </div>
                <div className="col s12 m4 mb-3">
                    <span>{ phoneNumber }</span>
                </div>
                <div className="col s12 m6 mb-3">
                    <span>{ address }</span>
                </div>         
            </div>
            {
                ordLevel.length !== 0 && (
                    <>
                        <h5 className="is-size-5 has-text-weight-semibold mt-5  grey-text text-darken-3">O' level Examination Results</h5>
                        <PreviewTableOne ordLevel={ordLevel}/>
                    </>
                )
            }
            {
                tertiary.length !== 0 && (
                    <>
                        <h5 className="is-size-5 has-text-weight-semibold mt-5 mb-5 grey-text text-darken-3">Tertiary / Polytechnic / College Examination Results</h5>
                        <PreviewTableTwo tertiary={tertiary}/>
                    </>
                )
            }
            {
                work.length !== 0 && (
                    <>
                        <h5 className="is-size-5 has-text-weight-semibold mt-5 mb-5 grey-text text-darken-3">Employment</h5>
                        <PreviewTableThree work={work}/>
                    </>
                )
            }
            {
                files.length !== 0 && <PreviewTableFour files={files}/>
            }
            {/* modal */}
            <div id="successModal" className="modal smooth-edge-2">
                <div className="modal-content center"> 
                    <FaCheckSquare fontSize="3rem" className="mt-4 make-green"/>
                    <h4 className=" is-size-4-touch is-size-3-desktop grey-text text-darken-2 mt-3 has-text-weight-semibold">Application Received</h4>
                    <p className="grey-text text-darken-1 is-size-6 mt-4">Your application has been received successfully. Our admission department will review your application and if accepted you will be contacted via your email.</p>           
                </div>
                <div className="modal-footer">
                    <a 
                        href="#!" className="modal-close main-color button"
                        onClick={backToHone}
                    >Close</a>
                </div>
            </div>
            <div id="errorModal" className="modal smooth-edge-2">
                <div className="modal-content center"> 
                    <ImCross fontSize="3rem" className="mt-4 main-color-text"/>
                    <h4 className=" is-size-4-touch is-size-3-desktop grey-text text-darken-2 mt-3 has-text-weight-semibold">Error Occured</h4>
                    <p className="grey-text text-darken-1 is-size-6 mt-4">Sorry your application could not be submitted, Please try again.</p>           
                </div>
                <div className="modal-footer">
                    <a href="#!" className="modal-close main-color button">Close</a>
                </div>
            </div>
        </>
    );
}
 
export default PreviewApplication;